import { Component, OnInit } from "@angular/core";
import { AccountDetailViewModel, IInfoCardData } from "@tylertech/tyler-api-types";
import { ICustomViewComponent } from "@tylertech/custom-view";

@Component({
    selector: "project-account-detail-card",
    templateUrl: "./projectAccountDetailCard.tmpl.html",
    standalone: false
})
export class ProjectAccountDetailCardComponent implements OnInit, ICustomViewComponent<IInfoCardData>
{
    readonly customDataBinding: IInfoCardData;

    get id(): string { return this.customDataBinding?.Id; }
    private get item(): IInfoCardData { return this.customDataBinding; }

    detail: AccountDetailViewModel;
    init: boolean;

    ngOnInit(): void
    {
        this.detail = this.item.DataElements.find(x => x.Name === "Detail")?.Value as AccountDetailViewModel;
        this.init = true;
    }
}
